/**
 * PDP shipping countdown — store timezone, weekday rules:
 * Mon–Fri before cutoff: countdown + ships today
 * Mon–Thu after cutoff: ships tomorrow
 * Fri after cutoff + Sat/Sun: ships Monday
 */
(function () {
  'use strict';

  var WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
  var MON_THU = ['Mon', 'Tue', 'Wed', 'Thu'];

  function getZonedParts(date, timeZone) {
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    });
    var parts = {};
    fmt.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') parts[part.type] = part.value;
    });
    return parts;
  }

  function formatDur(ms) {
    if (ms <= 0) return '0 min 0 sek';
    var totalSec = Math.floor(ms / 1000);
    var h = Math.floor(totalSec / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var sec = totalSec % 60;
    if (h > 0) return h + ' timer ' + m + ' min ' + sec + ' sek';
    return m + ' min ' + sec + ' sek';
  }

  function msUntilCutoff(now, timeZone, cutoffHour, cutoffMinute) {
    var parts = getZonedParts(now, timeZone);
    var nowSec = parseInt(parts.hour, 10) * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10);
    var cutoffSec = cutoffHour * 3600 + cutoffMinute * 60;
    return Math.max(0, (cutoffSec - nowSec) * 1000);
  }

  function isBeforeCutoff(parts, cutoffHour, cutoffMinute) {
    var hour = parseInt(parts.hour, 10);
    var minute = parseInt(parts.minute, 10);
    return hour < cutoffHour || (hour === cutoffHour && minute < cutoffMinute);
  }

  function updateEl(el) {
    var live = el.querySelector('[data-pdp-shipping-countdown-live]');
    if (!live) return;

    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    var cutoffMinute = parseInt(el.getAttribute('data-cutoff-minute'), 10);
    if (isNaN(cutoffHour)) cutoffHour = 12;
    if (isNaN(cutoffMinute)) cutoffMinute = 0;

    var timeZone = el.getAttribute('data-timezone') || 'Europe/Oslo';
    var msgBefore = el.getAttribute('data-msg-before') || '';
    var msgAfter = el.getAttribute('data-msg-after') || '';
    var msgTomorrow = el.getAttribute('data-msg-tomorrow') || el.getAttribute('data-msg-cutoff') || '';
    var msgMonday = el.getAttribute('data-msg-monday') || el.getAttribute('data-msg-cutoff') || '';

    var now = new Date();
    var parts = getZonedParts(now, timeZone);
    var day = parts.weekday;
    var beforeCutoff = isBeforeCutoff(parts, cutoffHour, cutoffMinute);
    var isWeekday = WEEKDAYS.indexOf(day) !== -1;

    if (isWeekday && beforeCutoff) {
      live.textContent = msgBefore + formatDur(msUntilCutoff(now, timeZone, cutoffHour, cutoffMinute)) + msgAfter;
      return;
    }

    if (MON_THU.indexOf(day) !== -1 && !beforeCutoff) {
      live.textContent = msgTomorrow;
      return;
    }

    live.textContent = msgMonday;
  }

  function tickAll() {
    document.querySelectorAll('[data-pdp-shipping-countdown]').forEach(updateEl);
  }

  function init() {
    tickAll();
    if (!window.__pdpShippingCountdownTimerId) {
      window.__pdpShippingCountdownTimerId = window.setInterval(tickAll, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', tickAll);
})();
